import React from 'react';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';

import { SettingsSectionWrapper } from 'legacyComponents/styled/lib';

import { BillingSubscription } from 'apps/payment/subscription';
import { PaymentMethods } from 'apps/payment/method';
import { PaymentHistory } from 'apps/payment/history';

@inject('routerStore')
@observer
export class BillingSettings extends React.Component {
  render() {
    return (
      <SettingsSectionWrapper>
        <BillingSubscription />
        <PaymentMethods />
        <PaymentHistory />
      </SettingsSectionWrapper>
    );
  }
}

BillingSettings.propTypes = {
  routerStore: PropTypes.object,
};
